import { MeetingType } from 'commons/types/meetingsTypes';

export interface ScheduleType {
  id?: string;
  meeting: {
    date: string;
    doctorID: string;
  };
  hasCMU: boolean | undefined;
  hasAcceptedCGU1: boolean;
  hasAcceptedCGU2: boolean;
  hasAcceptedCGU3: boolean;
  type: MeetingType;
  serviceID: string;
}

export function defaultSchedule(
  type: MeetingType,
  serviceID: string = '',
  id: string = '',
  doctorID: string = '',
): ScheduleType {
  return {
    id,
    type,
    meeting: {
      date: '',
      doctorID,
    },
    hasCMU: undefined,
    hasAcceptedCGU1: false,
    hasAcceptedCGU2: false,
    hasAcceptedCGU3: false,
    serviceID,
  };
}
